import React, {
    useEffect, useCallback, useContext, useState
} from 'react';
import { Loader, Link } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from 'gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { ClaimService } from 'gw-capability-claim';
import metadata from './FNOLClaimSummaryComponent_AX.metadata.json5';
import messages from './FNOLClaimSummaryComponent_AX.messages';
import styles from './FNOLClaimSummaryComponent_AX.module.scss';

const FNOLClaimSummaryComponentAX = (props) => {
    const { authHeader } = useAuthentication();
    const {
        fullPolicy,
        claimReportDTO,
        claimCreated,
        setClaimCreated,
        setClaimSummaryDTO,
        claimSummaryDTO,
    } = props;
    const translator = useContext(TranslatorContext);
    const [isLoading, setLoadingState] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);

    const createClaim = useCallback(async () => {
        setLoadingState(true);

        await ClaimService.reportQuickClaimSummary(claimReportDTO.value,
            fullPolicy, authHeader)
            .then(
                (result) => {
                    setClaimSummaryDTO(result);
                    setClaimCreated(true);
                }
            ).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('Error: ', error);
            })
            .finally(() => {
                setLoadingState(false);
            });
    }, [authHeader, claimReportDTO.value, fullPolicy, setClaimCreated, setClaimSummaryDTO]);

    const serviceRequestCell = useCallback(({ serviceRequestNumber }) => {
        return (
            <Link className={styles.serviceRequestCell} to={`/service-request-details/${serviceRequestNumber}`}>
                {serviceRequestNumber}
            </Link>
        );
    }, []);

    useEffect(() => {
        if (!claimCreated) {
            setClaimSummaryDTO(viewModelService.create(
                {},
                'cc',
                'edge.capabilities.claim.summary.dto.AXServiceClaimSummaryDTO'
            ));
            createClaim();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const subTitle = useCallback(() => {
        if (!claimCreated) {
            return '';
        }
        return (translator(messages.subTitle) + claimSummaryDTO.claimNumber
        + translator(messages.subTitle2));
    }, [claimCreated, claimSummaryDTO.claimNumber, translator]);

    const title = useCallback(() => {
        if (!claimCreated) {
            return translator(messages.errorMessage);
        }
        return translator(messages.title);
    }, [claimCreated, translator]);

    const resetPage = useCallback(() => {
        window.location.reload();
    }, []);

    if (isLoading) {
        return (
            <Loader
                loaded={!isLoading}
                text={translator(messages.creatingClaimLoadingMessage)}
            />
        );
    }

    const overrides = {
        summaryTable: {
            data: _.get(claimSummaryDTO, 'serviceRequests'),
            visible: claimCreated
        },
        serviceRequestNumber: {
            renderCell: serviceRequestCell
        },
        claimResultInlineNotification: {
            type: claimCreated ? 'success' : 'error',
            message: claimCreated ? subTitle() : title(),
            messageProps: {
                success: title()
            }
        },
        buttonsRow: {
            visible: claimCreated
        },
        createNewClaim: {
            onClick: resetPage
        }
    };

    return (
        < >
            <ViewModelForm
                uiProps={metadata.claimSummaryComponentContent}
                model={claimSummaryDTO}
                overrideProps={overrides}
            />
        </>
    );
};

export default withRouter(FNOLClaimSummaryComponentAX);
